/**
 * Initialize reusable component modules.
 *
 * Add shared UI behaviors here as the theme grows.
 *
 * @param {Document} root
 */

import { initFooter } from "./footer.js";

export function initComponentModules(root = document) {
  initFooter(root);
}
